enum ActionTypes {
  CONNECT = "app/network/CONNECT",
  DISCONNECT = "app/network/DISCONNECT",
  RESET = "app/network/RESET",
  SET_NETWORK_INFO = "app/network/SET_NETWORK_INFO",
}

export default ActionTypes;
